import { Directive, AfterViewInit, ElementRef, Renderer2, Input } from '@angular/core';
import { DomController } from '@ionic/angular';

@Directive({
  selector: '[channelUrl]'
})
export class ChannelPropertiesDirective implements AfterViewInit {
  channelPath: string;
  // tslint:disable-next-line:no-input-rename
  @Input('channelUrl') channelUrl: string;
  private header: HTMLDivElement;
  private mainContent: HTMLDivElement;

  constructor(private domCtrl: DomController, private renderer: Renderer2, public el: ElementRef) { 
    this.channelPath = this.channelUrl;
    this.renderer.setStyle(el.nativeElement, 'background-image', 'url(' + this.channelPath + ')');
  }

  ngAfterViewInit() {
    this.channelPath = this.channelUrl;
    console.log('video baground url', this.channelPath);
    this.renderer.setStyle(this.el.nativeElement, 'background-image', 'url(' + this.channelPath + ')');
    // this.renderer.setStyle(this.el.nativeElement, 'opacity', '.7');
    this.renderer.setStyle(this.el.nativeElement, 'text-shadow', '3px 3px 5px #000');
  }

}
